import { cloneDeep } from 'lodash';
import { JsonObject } from '@/lib/helpers';
import { ClassifierModel, ClassifierSubType } from './classifier.model';
import { IntentClassifierModel } from './intent.model';
import { RegexClassifierModel } from './regex.model';

export {
  ClassifierModel,
  ClassifierSubType,
  ClassifierType,
  CreateClassifierModel,
} from './classifier.model';
export type { ClassifierCreateOption, ClassifierUsage } from './classifier.model';

export { IntentClassifierModel } from './intent.model';
export { RegexClassifierModel } from './regex.model';

export const ClassifierMap: Map<ClassifierSubType, ClassifierModel> = new Map();

ClassifierMap.set(ClassifierSubType.Custom, new IntentClassifierModel());
ClassifierMap.set(ClassifierSubType.Regex, new RegexClassifierModel());

export const getTypedClassifier = (model: ClassifierModel) => {
  const typedModel = ClassifierMap.get(model.subtype);

  if (!typedModel) {
    return model;
  }

  const Constructor = typedModel.constructor as new (data?: JsonObject) => typeof typedModel;

  const config = {
    ...typedModel.config,
    ...model.config,
  };

  const data = cloneDeep({ ...model._props, config });

  return new Constructor(data)!;
};
